import {SubscriptionOrderBy} from '~shared/schema/wiki/actions/subscriptions';

import {i18n} from '~ui/components/AsideNavigation/i18n';

import {makeEpic, PAGE_SIZE} from '../common';

import {actions} from './slice';
import {SubscriptionTypes} from './types';

const subscriptionsEpicTypes = [
    actions.init.type,
    actions.setQueryFilter.type,
    actions.setTypeFilter.type,
    actions.loadNextPage.type,
    actions.changeOrder.type,
];

export const subscriptionsEpic = makeEpic(
    (state) => state.subscriptions,
    (subscriptions, {sdk}) =>
        sdk.wiki.getSubscriptions({
            cursor: subscriptions.nextCursor ? subscriptions.nextCursor : undefined,
            pageSize: PAGE_SIZE,
            orderBy: toSubscriptionsOrderBy(subscriptions.orderBy),
            orderDirection: subscriptions.orderDirection,
            query: subscriptions.filters.query,
            type:
                subscriptions.filters.type === SubscriptionTypes.All
                    ? undefined
                    : subscriptions.filters.type,
        }),
    actions,
    subscriptionsEpicTypes,
    i18n('subscriptions-error'),
);

const toSubscriptionsOrderBy = (orderBy: string) => {
    let result: SubscriptionOrderBy | undefined;
    switch (orderBy) {
        case 'title':
            result = 'page.title';
            break;
        case 'slug':
            result = 'page.slug';
            break;
        case 'author':
            result = 'page.author';
            break;
        case 'pageModifiedAt':
            result = 'page.modified_at';
            break;
        case 'pageCreatedAt':
            result = 'page.created_at';
            break;
    }
    return result;
};
